/**
 * Node modules
 */
import VendorAntBreadcrumb from 'antd/lib/breadcrumb';

VendorAntBreadcrumb.displayName = 'VendorAntBreadcrumb';
export default VendorAntBreadcrumb;
